const AnimatedPage = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default AnimatedPage; 